import React from 'react'
import _ from 'underscore'
import { Button as UIButton } from '@/components/ui/button'
import { cn } from '@/lib/utils'

// Legacy bootstrap tokens mapped onto the shadcn cva variants/sizes. Any
// unmapped classes (custom theme classes, tailwind utilities) pass through.
const VARIANTS = {
  'btn-primary': 'default',
  'btn-success': 'default',
  'btn-danger': 'destructive',
  'btn-default': 'outline',
  'btn-secondary': 'outline',
  'btn-link': 'link',
}

const SIZES = {
  'btn-sm': 'sm',
  'btn-xs': 'sm',
  'btn-lg': 'lg',
}

class Button extends React.Component {

  componentDidMount() {
    this.throttledOnclick = _.throttle(this.props.onClick, 2000)
  }

  onClick = () => {
    if (this.props.onClick) {
      this.throttledOnclick(this.props.value)
    }
  }

  render() {
    let variant = null
    let size = null
    const passthrough = []

    if (this.props.className) {
      this.props.className.split(/\s+/).forEach((token) => {
        if (VARIANTS[token]) {
          variant = variant || VARIANTS[token]
        }
        else if (SIZES[token]) {
          size = size || SIZES[token]
        }
        else if (token === 'btn-block') {
          passthrough.push('w-full')
        }
        else if (token && token !== 'btn') {
          passthrough.push(token)
        }
      })
    }
    else {
      // Legacy default was "btn btn-default btn-block btn-lg".
      variant = 'outline'
      size = 'lg'
      passthrough.push('w-full')
    }

    return (
      <UIButton
        type="button"
        tabIndex={-1}
        variant={variant || 'ghost'}
        size={size || 'default'}
        aria-pressed={this.props.pressed ? true : undefined}
        onClick={this.onClick}
        className={cn(
          this.props.pressed && 'bg-muted text-foreground',
          // Legacy `disabled` was visual only — clicks still fired.
          this.props.disabled && 'cursor-not-allowed opacity-50',
          passthrough
        )}
      >
        {this.props.children}
      </UIButton>
    )
  }
}

export default Button
